import {ReactComponent as QuoteIcon} from './quote.svg'

function Quote() {
  return <QuoteIcon />
}

export default Quote
